import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { SiFacebook, SiInstagram, SiLinkedin, SiTwitter } from "react-icons/si";
import { BsTelephoneFill } from "react-icons/bs";
import { MdEmail, MdLocationOn } from "react-icons/md";

function Footer() {
  const { t } = useTranslation();
  return (
    <footer className="footer">
      <div className="footer__grid">

        {/* Brand column */}
        <div className="footer__brand-col">
          <img
            src="https://res.cloudinary.com/dnfpmrdjl/image/upload/v1664923945/new-logo-white-1_iaea1q.png"
            className="logo footer__logo"
            alt="Ako Assurance Sarl logo"
          />
          <p className="footer__brand-tagline">
            {t("footer_tagline")}
          </p>
          <div className="footer__social-links">
            <span className="footer__social-links-label">{t("footer_follow_us_short")}</span>
            <div className="footer__social-icons">
              <a href="https://www.facebook.com/profile.php?id=100083826097894" target="_blank" rel="noreferrer" aria-label="Facebook">
                <SiFacebook size={16} />
              </a>
              <a href="https://twitter.com" target="_blank" rel="noreferrer" aria-label="Twitter">
                <SiTwitter size={16} />
              </a>
              <a href="https://www.instagram.com" target="_blank" rel="noreferrer" aria-label="Instagram">
                <SiInstagram size={16} />
              </a>
              <a href="https://www.linkedin.com/company/ako-assurance-sarl/" target="_blank" rel="noreferrer" aria-label="LinkedIn">
                <SiLinkedin size={16} />
              </a>
            </div>
          </div>
        </div>

        {/* Navigation column */}
        <div className="footer__nav-col">
          <h4 className="footer__col-title">Navigation</h4>
          <ul className="footer__link-list">
            <li><Link to="/">{t("nav_home_link")}</Link></li>
            <li><Link to="/about">{t("footer_about_us_link")}</Link></li>
            <li><Link to="/insurrances">{t("footer_our_insurrances_link")}</Link></li>
            <li><Link to="/blog">{t("footer_blog_link")}</Link></li>
            <li><Link to="/contact">Contact</Link></li>
          </ul>
        </div>

        {/* Online Services column */}
        <div className="footer__services-col">
          <h4 className="footer__col-title">{t("footer_our_online-services_link")}</h4>
          <ul className="footer__link-list">
            <li><Link to="/online-services">{t("nav_online_services_link")}</Link></li>
            <li><Link to="/online-services/invoices">{t("invoice_page_header_title")}</Link></li>
            <li><Link to="/online-services/claim-report">{t("claim-report_page_header_title")}</Link></li>
          </ul>
        </div>

        {/* Contact column */}
        <div className="footer__contact-col">
          <h4 className="footer__col-title">Contact</h4>
          <ul className="footer__contact-list">
            <li className="footer__contact-item">
              <BsTelephoneFill size={14} />
              <span>+237 699 38 71 63</span>
            </li>
            <li className="footer__contact-item">
              <BsTelephoneFill size={14} />
              <span>+237 677 51 25 82</span>
            </li>
            <li className="footer__contact-item">
              <MdEmail size={16} />
              <span>ako_assurances@yahoo.fr</span>
            </li>
            <li className="footer__contact-item">
              <MdLocationOn size={16} />
              <span>Yaoundé, Cameroun</span>
            </li>
          </ul>
        </div>
      </div>

      <hr className="footer__divider" />

      <div className="text-center footer-copyright">
        &copy; 2015 – {new Date().getFullYear()}{" "}
        {t("footer_ako_all_rights_reserved")}
      </div>
    </footer>
  );
}

export default Footer;
